export * from "./rich-text-editor.component";
